module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_maedori@2x-656ed46d1646bb8a18c220be88bd4639.webp";